import { render } from "./register-form.vue?vue&type=template&id=10e7a110&scoped=true"
import script from "./register-form.vue?vue&type=script&lang=js"
export * from "./register-form.vue?vue&type=script&lang=js"

import "./register-form.vue?vue&type=style&index=0&id=10e7a110&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e7a110"]])

export default __exports__